var $1b5d6c6c47d55106$exports = {};
$1b5d6c6c47d55106$exports = {
  "ascending": "croissant",
  "ascendingSort": function ascendingSort(args) {
    return "tri\xE9 en fonction de la colonne\xA0".concat(args.columnName, " par ordre croissant");
  },
  "columnSize": function columnSize(args) {
    return "".concat(args.value, "\xA0pixels");
  },
  "descending": "d\xE9croissant",
  "descendingSort": function descendingSort(args) {
    return "tri\xE9 en fonction de la colonne\xA0".concat(args.columnName, " par ordre d\xE9croissant");
  },
  "resizerDescription": "Appuyez sur Entr\xE9e pour commencer le redimensionnement.",
  "select": "S\xE9lectionner",
  "selectAll": "S\xE9lectionner tout",
  "sortable": "colonne triable"
};
export { $1b5d6c6c47d55106$exports as default };